
    import {defineComponent, SetupContext, ref, PropType, computed} from 'vue'
    import useStore from '@/hooks/useStore'
    import { searchMessageOnReply } from '@/store/reply'
    import { MessageContent } from '@/types/message'
    import { formatMessage } from '@/helpers/messages'

    import MessageInteract from '@/components/Message/MessageInteract.vue'
    import MessageHour from '@/components/Message/MessageHour.vue'
    import useMessage from '@/hooks/useMessage'

    export default defineComponent({
        components: {
            MessageHour,
            MessageInteract
        },

        emits: ['onClick'],

        props: {
            modelValue: {
                type: Object as PropType<MessageContent>,
                default: () => ({})
            }
        },

        setup(props, {emit}: SetupContext) {
            const store = useStore()

            const state = ref<MessageContent>(props.modelValue)
            const onFocus = ref<boolean>(false)
            const color = store.data.bgColor
            // const legend = 'Aqui vem a legenda da imagem'
            const legend = computed(() => {
                if (props.modelValue?.legend) {
                    return props.modelValue.legend
                }
                return ''
            })

            function handleClickInteract(id: string): void {
                if (searchMessageOnReply(id)) {
                    onFocus.value = !onFocus.value
                }
            }

            const backgroundColor = useMessage().defineBackgroundColor(state.value?.position ?? '')
            const image = computed(() => {
                let dominioAtual = window.location.origin
                const img = state.value?.message ?? state.value?.content
                // TODO - padronizar a imagem, quando o chatmix envia é content, quando ele recebe é message
                if(img.includes('chatmix') || img.includes(dominioAtual)) {
                    return img
                }
                // caso nao seja o localhost, adicionar o /api_v2
                if (!dominioAtual.includes('localhost') ) {
                    dominioAtual = dominioAtual + '/api_v2'
                }
                return `${dominioAtual}/api/v1/library/file?url=${img}`
            })
            return {
                emit,
                image,
                handleClickInteract,
                onFocus,
                color,
                legend,
                state,
                formatMessage,
                backgroundColor
            }
        }
    })
